import { useAuthContext } from "../../../hooks/useAuthContext";

function Cover() {
  const { dispatch } = useAuthContext();
  localStorage.removeItem('user');

  dispatch({type: 'LOGOUT'});

  return;
}

export default Cover;
